import { ApiNewDokumentPowiazanyDalDto, EgibObject } from '@gk/gk-modules';
import { WorkspaceState } from '../../../../services/request-workspace-state/request-workspace-state.model';
import {
  DocumentationFormType,
  ExtendedApplicantRequest,
  ExtendedApplicantRequestDto,
} from '../../../../shared/base-new-request/base-new-request.model';
import { InvestorDetails } from '../../../../shared/investor-details/investor-details.model';
import { Shipping } from '../../../../shared/shipping-form/shipping-form.model';

export interface HSTNNewRequestDto extends ExtendedApplicantRequestDto {
  OpisProwadzonejDzialalnosci: string;
  CzasFunkcjonowaniaInstalacji: string;
  WielkoscRodzajEmisji: string;
  MetodyOgraniczeniaEmisji: string;
  CzyOgraniczenieZgodneZPrzepisami: string;
}

export class HSTNNewRequest extends ExtendedApplicantRequest {
  constructor(
    investorDetails: InvestorDetails,
    documentationForm: DocumentationFormType,
    shippingForm: Shipping,
    proxyDetailsCheckbox: boolean,
    proxyDetailsArray: InvestorDetails[],
    public activityDescription: string,
    public installationOperatingTime: string,
    public emissionTypeAndAmount: string,
    public emissionReductionMethods: string,
    public reductionCompliantDescription: string,
  ) {
    super(
      investorDetails,
      documentationForm,
      shippingForm,
      undefined,
      undefined,
      proxyDetailsCheckbox,
      proxyDetailsArray,
    );
  }

  static fromAppToApi(
    data: HSTNNewRequest,
    parcels: EgibObject[],
    files: ApiNewDokumentPowiazanyDalDto[],
  ): HSTNNewRequestDto {
    return {
      ...ExtendedApplicantRequest.mapCommonFields({
        data,
        files,
        parcels,
      }),
      OpisProwadzonejDzialalnosci: data.activityDescription,
      CzasFunkcjonowaniaInstalacji: data.installationOperatingTime,
      WielkoscRodzajEmisji: data.emissionTypeAndAmount,
      MetodyOgraniczeniaEmisji: data.emissionReductionMethods,
      CzyOgraniczenieZgodneZPrzepisami: data.reductionCompliantDescription,
    };
  }
}

export interface HSTNNewRequestFormWorkspaceState extends WorkspaceState {
  formValue: HSTNNewRequest;
  parcels: EgibObject[];
}
